import {gql} from '@apollo/client'

export const GET_DEBIT = gql`
  query GetDebit($debitId: ID!) {
    debit(id: $debitId) {
      id
      description
      amount
      date
      state
      xeroLink
      invoice {
        id
        invoiceNumber
      }
    }
  }
`

export const CREATE_DEBIT = gql`
  mutation CreateOrUpdateDebit($description: String, $amount: Float, $date: String, $accountId: ID, $state: String) {
    debit(description: $description, amount: $amount, date: $date, accountId: $accountId, state: $state) {
      id
      description
      amount
      date
      state
    }
  }
`

export const UPDATE_DEBIT = gql`
  mutation CreateOrUpdateDebit(
    $debitId: ID!
    $description: String
    $amount: Float
    $date: String
    $accountId: ID
    $state: String
  ) {
    debit(id: $debitId, description: $description, amount: $amount, date: $date, accountId: $accountId, state: $state) {
      id
      description
      amount
      date
      state
    }
  }
`
